// import { Injectable } from '@angular/core';

// // After
// import {Events} from '../services/Events';

// @Injectable()
// export class UserData {
//     HAS_LOGGED_IN = 'hasLoggedIn';
//     public LOGGED_IN: boolean;
//     public bgImage = '';
//     public circle = '';
//     constructor(public events: Events) {
//         this.LOGGED_IN = false;
//     }
 
//     login(user) {
//         // console.log("inside login function in service")
//         this.LOGGED_IN = true;
//         localStorage.setItem('hasLoggedIn','true');
//         this.setUser(user);
//         this.events.publish('user:login', {});
//          this.events.publish('user:data', user);
//     };

//     // logout() {
//     //     // console.log("inside logout function in service")
//     //     this.LOGGED_IN = false;
//     //     localStorage.removeItem('hasLoggedIn');
//     //     localStorage.removeItem('token');
//     //     localStorage.removeItem('user');
//     //     localStorage.removeItem('type');
//     //     this.events.publish('user:logout',{});
        
//     // };
//     logout() {
//   this.LOGGED_IN = false;

//   localStorage.clear();
//   sessionStorage.clear();

//   this.events.publish('user:logout', {});
//     Promise.resolve().then(() => window.location.reload());
//      // or router.navigateByUrl('/login')
// }


//     setUser(user) {
//         localStorage.setItem('user',user);
//     };

//     setActiveCode(code) {
//         console.log(code);
//     };

//     getActiveCode() {
//         return '1';
         
//     };

//     getUser() {
//         return localStorage.getItem('user');
//     };

//     getUserToken() {
//         return localStorage.getItem('token');
//     };

//     // return a promise
//     hasLoggedIn() {
//         return localStorage.getItem('hasLoggedIn');

//     };
// }

import { Injectable } from '@angular/core';
import { Events } from '../services/Events';

@Injectable({
  providedIn: 'root'
})
export class UserData {

  private LOGGED_IN_KEY = 'hasLoggedIn';

  public LOGGED_IN = false;

  constructor(private events: Events) {
    this.LOGGED_IN = !!localStorage.getItem(this.LOGGED_IN_KEY);
  }

  // =====================
  // LOGIN
  // =====================
  login(data: any) {

    this.LOGGED_IN = true;

    localStorage.setItem(this.LOGGED_IN_KEY, 'true');

    // token
    if (data.access_token) {
      localStorage.setItem('token', data.access_token);
    }

    // user
    if (data.user) {
      localStorage.setItem('user', JSON.stringify(data.user));
    }

    // role
    if (data.role !== undefined) {
      localStorage.setItem('role', String(data.role));
    }

    this.events.publish('user:login', {});
    this.events.publish('user:data', data);
  }

  // =====================
  // LOGOUT
  // =====================
  logout() {

    this.LOGGED_IN = false;

    localStorage.clear();
    sessionStorage.clear();

    this.events.publish('user:logout', {});

    window.location.reload();
  }

  // =====================
  // USER DATA
  // =====================
  getUser(): any {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  getRole(): number {
    return Number(localStorage.getItem('role'));
  }

  // =====================
  // LOGIN STATUS
  // =====================
  hasLoggedIn(): boolean {
    return localStorage.getItem(this.LOGGED_IN_KEY) === 'true';
  }
}
